module.exports = __webpack_public_path__ + "static/media/COPING_MIXED_NEIGHTER.87e1c3f9.md";